import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { DrilldownMappingAPIResponse } from "../../../../../src/types/DataDD/DataDD"
import { URLs } from "../../../../Constants/Consts"
import { fetchApi, getByPath, splitOnCapitals } from "../../../../Helpers/Functions"
import { updateCheckListItem } from "../../../../store/SequenceObject"
import { RootState } from "../../../../store/store"
import { TCheckListLink, UnitChecklistItem } from "../../../../types/types"

export default function ({ path, CheckListItemUuid }) {
  const [isLoading, setIsLoading] = useState(false)
  const { ChecklistsObject } = useSelector((state: RootState) => state.SequenceObject)
  // const checkListItem = SequencesObject[SequenceId][UnitId][CheckListItemUuid];
  const checkListItem = getByPath(path, ChecklistsObject)

  const dispatch = useDispatch()
  useEffect(() => {
    (async () => {
      try {
        if (navigator.onLine) {
          setIsLoading(true)
          const checkListItem = await fetchApi(URLs.getChecListItemUrl(CheckListItemUuid)).then(res => res.json()) as UnitChecklistItem
          // update redux store
          dispatch(updateCheckListItem({ completePath: path, checklistItem: checkListItem }))
        }
      } finally {
        setIsLoading(false)
      }
    })()
  }, [])
  return { item: checkListItem, isLoading }

}

interface FieldItem {
  name: string;
  value: any;
  link?: boolean;
}

export const getDetilsFieldsArray = (
  item: any /* UnitChecklistItem */,
  detailsEnum: DrilldownMappingAPIResponse
): FieldItem[] => {
  const transformLinkItem = (link: TCheckListLink): FieldItem => ({
    name: link?.linkCategory,
    value: link,
    link: true
  });


  const defaultLinks = [
    { name: 'Brightspace', value: null, link: true },
    { name: 'Vimeo', value: null, link: true },
    { name: 'Information Hub', value: null, link: true },
    { name: 'SharePoint', value: null, link: true }
  ]

  const transformTableItem = (key: string): FieldItem | undefined => {
    if (key === "statusId") {
      return { name: "Status", value: item[key] };
    }

    if (!detailsEnum[key] || typeof detailsEnum[key] !== "string") {
      return undefined;
    }

    return {
      name: splitOnCapitals(detailsEnum[key]),
      value: item[key]
    };
  };
  
  // const linksData = item.link?.map(transformLinkItem).filter(Boolean) ?? [];
  const linksData = item.link.length ? item.link.map(transformLinkItem) : defaultLinks
  const tableData = Object.keys(item ?? {}).map(transformTableItem).filter(Boolean) || [];

  return [...tableData, ...linksData];
};
